import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verify: () => api.get('/auth/verify'),
};

// Expenses API
export const expensesAPI = {
  getAll: (search = '') => api.get(`/expenses?search=${search}`),
  getOne: (id) => api.get(`/expenses/${id}`),
  getFile: (id) => api.get(`/expenses/${id}/file`, { responseType: 'blob' }),
  create: (formData) => api.post('/expenses', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, formData) => api.put(`/expenses/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/expenses/${id}`),
};

// Settings API
export const settingsAPI = {
  getViewableYear: () => api.get('/settings/viewable-year'),
  setViewableYear: (year) => api.put('/settings/viewable-year', { year }),
  getAvailableYears: () => api.get('/settings/available-years'),
};

export default api;